module.exports = __webpack_public_path__ + "static/seo-image-caf1ef85ac8585bce6b0ab4b1d02c161.png";